<template>
	<footer class='app-footer' v-bind:class="{'collapsed': !collapsed}">
		<div class="app-footer-expand" v-on:click="toggle">

			<span class="sprvsr-logo"></span>
			<span class="expand-arrow"><i></i></span>
		</div>
		<nav class="navbar navbar-expand-md text-white ">
			<div class="play-button-container">
				<a class="text-white" v-if="timeInterface" href="#" @click.stop.prevent="start">
					<span :class="paused? 'play-button': 'pause-button'"><i></i></span>
				</a>
			</div>

			<div class="collapse navbar-collapse app-nav text-white">
				<ul class="navbar-nav app-nav" v-if="timeInterface">

					<li :class="havoc?'nav-item border-left border-right havoc-container active':'nav-item border-left border-right havoc-container'">
						<a href="#" class="nav-link text-white px-3" @click.stop.prevent="toggleHavoc">
							<i></i>
							<span class="text">{{havoc?'Deactivate':'Activate'}}</span>
						</a>
					</li>
					<li class="nav-item border-right time-warp">
						<span class="logo"><i></i></span>
						<div class="row no-gutters">
							<div class="col-3 border-right">
								<a href="#" @click.prevent="toggleSpeed" class="d-block">
									<i class="app-icon fast-forward"></i>
								</a>
							</div>
							<div class="col-6 border-right count">
								x{{speed}}
							</div>
							<div class="col-3">
								<a href="#" v-b-modal.simulatorModal class="" @click.prevent>
									<i class="app-icon skip-forward"></i>
								</a>
							</div>

						</div>
					</li>
					<li class="nav-item border-right taskmaster">
						<TaskMaster/>
					</li>
				</ul>

				<ul class="navbar-nav ml-auto app-nav footer-right-section">
					<!--<li class="nav-item">-->
						<!--<a class="nav-link text-white pl-4 pr-3" href="#" @click.stop.prevent="toggleView">-->
							<!--<span :class="liveView?'portal-view':'live-view'"><i></i>{{liveView?'Switch to Portal View':'Switch to Live View'}}</span>-->
						<!--</a>-->
					<!--</li>-->
					<li class="nav-item ">
						<a class="nav-link text-white pl-3 pr-3" href="#" @click.prevent="saveAction">
							<i class="app-icon app-icon-light mr-1 folder"></i> Save Scenario
						</a>
					</li>
					<li class="nav-item ">
						<a class="nav-link text-white pl-3 pr-3" href="#" @click.prevent="view='load'">
							<i class="app-icon archive mr-1"></i> Load Scenario
						</a>
					</li>
					<!--<li class="nav-item ">-->
						<!--<a class="nav-link text-white pl-3 pr-3" href="#" @click.prevent="loadAction">-->
							<!--<span class="settings"><i></i>Settings</span>-->
						<!--</a>-->
					<!--</li>-->
					<li class="nav-item ">
						<a class="nav-link text-white pl-3 pr-3" @click.prevent="exit_dialog=true" href="#">
							<span class="exit"><i></i>Exit</span>
						</a>
					</li>
				</ul>

			</div>
		</nav>
	</footer>
</template>


<script>

	import TaskMaster from '../../components/Game/TaskMaster.vue'
	import * as workerTimers from 'worker-timers';

	export default {
		name: 'FooterBlock',
		props: ['timeInterface'],
		computed: {
			speed: {
				get() {
					return this.$store.state.speed
				},
				set(value) {
					this.$store.commit('set_speed', value)
				}
			},
			logged: {
				get() {
					return this.$store.state.logged
				},
				set(value) {
					this.$store.commit('setState', ['logged', value])
				}
			},
			collapsed() {
				return !this.$store.state.bottom_menu_collapsed
			},
			map() {
				return this.$store.state.map.map
			},
			workers() {
				return this.$store.state.workers
			},
			paused: {
				get()  {
					return this.$store.state.paused
				},
				set(value) {
					this.$store.commit('setState', ['paused', value])
				}
			},
			save: {
				get() {
					return this.$store.state.load
				},
				set(value) {
					this.$store.commit('setState', ['save', value])
				}
			},
			havoc: {
				get() { return this.$store.state.havoc },
				set(value) { this.$store.commit('setState', ['havoc', value])}
			},
			view: {
				get() { return this.$store.state.view },
				set(value) { this.$store.commit('setState', ['view', value])}
			},
			exit_dialog: {
				get() { return this.$store.state.exit_dialog },
				set(value) { this.$store.commit('setState', ['exit_dialog', value])}
			},
		},
		data() {
			return {
				ini_speed: 0,
				speed_count: 1,
				open: true,
				liveView: false,
				map_to: null
			}
		},
		mounted() {
			this.ini_speed = 1;//this.speed;
		},
		methods: {
			toggle: function () {
				this.$store.commit('bottom_menu_toggle')
				let map = this.map;
				if (this.map_to) clearInterval(this.map_to);
				this.map_to = setInterval(function () {
					map.updateSize();
				}, 1);
				setTimeout(function () {
					clearInterval(this.map_to)
				}, 450);
			},
			start() {
				this.paused = !this.paused;

				if (!this.paused) this.$store.dispatch('start_time');
				else this.$store.dispatch('end_time');
			},
			loadAction() {
//				this.$store.dispatch('load');
			},
			saveAction() {

				this.save = true;
			},
			toggleHavoc(){
				this.havoc = !this.havoc
				for (let i in this.workers) {
					let worker = this.workers[i];
					if (this.havoc) {
						worker.safety_chance_bad = worker.safety_chance_bad * 50;
						//worker.chance_bad = worker.chance_bad * 50;
					}
					else {
						worker.safety_chance_bad = worker.safety_chance_bad / 50;
						//worker.chance_bad = worker.chance_bad / 50;
					}
				}

			},
			toggleView(){
				this.liveView = !this.liveView
			},
			toggleSpeed() {

				this.paused = false;

				let speed_options = this.$config.speed_options;
				let speed_option = speed_options[0];
				this.$store.dispatch('end_time');

				for (let i in speed_options) {
					if (speed_options[i] > this.speed) {
						speed_option = speed_options[i]
						break;
					}
				}
				this.speed = speed_option;
				this.$store.dispatch('start_time');
			}
		},
		components: {TaskMaster}
	}
</script>
